/**
 * @generated SignedSource<<2d0da9762e6a0b8c59eec85902655c6d>>
 * @relayHash 445b11fda94ba3ba0355212d55d4806a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 14707dc28e29b91c81cbef4f84c025b5ce82bc43c2f9f75a85206340a3f446a6

import type { ConcreteRequest } from 'relay-runtime';
export type CommentAgentSessionsQuery$variables = {
  pageId: string;
  status?: ReadonlyArray<string> | null;
};
export type CommentAgentSessionsQuery$data = {
  readonly content: {
    readonly nodes: ReadonlyArray<{
      readonly allCommentAgentSessions: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly agentSession: {
              readonly agent: {
                readonly id: string;
                readonly name: string;
                readonly picture: AGG$URL;
              } | null;
              readonly state: string | null;
            } | null;
            readonly conversationId: string | null;
            readonly subEntityId: string | null;
          } | null;
        } | null> | null;
      } | null;
      readonly id: string | null;
    } | null> | null;
  } | null;
};
export type CommentAgentSessionsQuery = {
  response: CommentAgentSessionsQuery$data;
  variables: CommentAgentSessionsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "pageId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "status"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "pageId"
  },
  {
    "kind": "Variable",
    "name": "status",
    "variableName": "status"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "id"
},
v3 = {
  "kind": "ScalarField",
  "name": "conversationId"
},
v4 = {
  "kind": "ScalarField",
  "name": "subEntityId"
},
v5 = {
  "kind": "ScalarField",
  "name": "state"
},
v6 = {
  "kind": "ScalarField",
  "name": "name"
},
v7 = {
  "kind": "ScalarField",
  "name": "picture"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "CommentAgentSessionsQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "PaginatedContentListWithChild",
        "kind": "LinkedField",
        "name": "content",
        "plural": false,
        "selections": [
          {
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              {
                "concreteType": "AgentSessionAssociationConnection",
                "kind": "LinkedField",
                "name": "allCommentAgentSessions",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "AgentSessionAssociationEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "AgentSessionAssociation",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v4/*: any*/),
                          {
                            "concreteType": "AgentSession",
                            "kind": "LinkedField",
                            "name": "agentSession",
                            "plural": false,
                            "selections": [
                              (v5/*: any*/),
                              {
                                "kind": "LinkedField",
                                "name": "agent",
                                "plural": false,
                                "selections": [
                                  (v2/*: any*/),
                                  (v6/*: any*/),
                                  (v7/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CommentAgentSessionsQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "PaginatedContentListWithChild",
        "kind": "LinkedField",
        "name": "content",
        "plural": false,
        "selections": [
          {
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              {
                "concreteType": "AgentSessionAssociationConnection",
                "kind": "LinkedField",
                "name": "allCommentAgentSessions",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "AgentSessionAssociationEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "AgentSessionAssociation",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v4/*: any*/),
                          {
                            "concreteType": "AgentSession",
                            "kind": "LinkedField",
                            "name": "agentSession",
                            "plural": false,
                            "selections": [
                              (v5/*: any*/),
                              {
                                "kind": "LinkedField",
                                "name": "agent",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                  },
                                  (v2/*: any*/),
                                  (v6/*: any*/),
                                  (v7/*: any*/)
                                ]
                              },
                              (v2/*: any*/)
                            ]
                          },
                          (v2/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "445b11fda94ba3ba0355212d55d4806a",
    "id": "14707dc28e29b91c81cbef4f84c025b5ce82bc43c2f9f75a85206340a3f446a6",
    "metadata": {},
    "name": "CommentAgentSessionsQuery",
    "operationKind": "query",
    "text": "query CommentAgentSessionsQuery($pageId:ID!,$status:[String!]){content(id:$pageId,status:$status){nodes{id,allCommentAgentSessions{edges{node{conversationId,subEntityId,agentSession{state,agent{__typename,id,name,picture},id},id}}}}}}"
  }
};
})();

(node as any).hash = "fab614361d1787e844fee670c9e22557";

export default node;
